import React from "react";

import "react-toastify/dist/ReactToastify.css";

import { ToastContainer } from "react-toastify";

function ToastContainerWrapper() {
  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
      toastStyle={{
        fontSize: "16px",
      }}
    />
  );
}

export default ToastContainerWrapper;
